export const ID_ONLINE = "ONLINE";
export const ID_POS = "POS";